





































import { computed, defineComponent } from '@vue/composition-api';
import { useCart } from '../../composable';
import { OfficeBuildingIcon } from '@vue-hero-icons/solid';

export default defineComponent({
    name: 'CartListItem',
    components: {
        OfficeBuildingIcon,
    },
    props: {
        asset: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const { removeFromCart } = useCart();

        const providedBy = computed(() => {
            return props.asset.organisation
                ? props.asset.organisation.businessName
                : `${props.asset.createdBy.firstName} ${props.asset.createdBy.lastName}`;
        });

        return { removeFromCart, providedBy };
    },
});
